<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-header">
                        <slot name="header"></slot>
                    </div>

                    <div class="modal-body">
                        <slot name="body"></slot>
                    </div>

                    <div class="modal-footer">
                        <slot name="footer">
                            <button 
                            class="modal-default-button btn rounded" 
                            :style="{background: `linear-gradient(to right, ${colors.thirth} 0%, ${colors.first} 50%, ${colors.fourth} 100%`}"
                            @click="$emit('close')">OK</button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>


<script>
export default {
    data: () =>({
        showModal: false
    }),
    created(){
        this.colors = this.$store.getters.getCustomColors
    }
}
</script>

<style lang="scss">
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 300px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.modal-header h3 {
    margin-top: 0;
    /* color: #42b983; */
    font-weight: 700;
    font-size: 25px;
    text-transform: uppercase;
    letter-spacing: 2px;
    text-align: center;
}

.modal-body {
    margin: 20px 0;

    h3{
            text-align: center;
    }
}

.modal-default-button {
    float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}
</style>
